import React, { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export interface SwitchDarkModeProps {
  className?: string;
}

const SwitchDarkMode: React.FC<SwitchDarkModeProps> = ({ className = "" }) => {
  const [isDarkMode, setIsDarkMode] = useState(
    document.documentElement.classList.contains("dark")
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDarkMode(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  const _toogleDarkMode = () => {
    if (document.documentElement.classList.contains("dark")) {
      document.documentElement.classList.remove("dark");
      localStorage.theme = "light";
    } else {
      document.documentElement.classList.add("dark");
      localStorage.theme = "dark";
    }
  };

  return (
    <button
      onClick={_toogleDarkMode}
      className={`relative w-12 h-12 rounded-2xl bg-neutral-100 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-300 hover:text-[#ff6600] dark:hover:text-[#ff6600] transition-all duration-300 focus:outline-none flex items-center justify-center group overflow-hidden ${className}`}
    >
      <span className="sr-only">Enable dark mode</span>
      <div className="relative w-6 h-6">
        <Sun 
          className={`absolute inset-0 transform transition-all duration-500 ease-spring ${
            isDarkMode ? "translate-y-10 opacity-0 rotate-45" : "translate-y-0 opacity-100 rotate-0"
          } stroke-[1.5]`}
        />
        <Moon 
          className={`absolute inset-0 transform transition-all duration-500 ease-spring ${
            !isDarkMode ? "-translate-y-10 opacity-0 -rotate-45" : "translate-y-0 opacity-100 rotate-0"
          } stroke-[1.5]`}
        />
      </div>
    </button>
  );
};

export default SwitchDarkMode;
